import React from "react";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";

function DummyLogout() {
  const cookies = new Cookies(null, { path: "/" });
  const navigate = useNavigate();

  cookies.remove('pravnoLice');
  cookies.remove('fizickoLice');

  setTimeout(() => {
    navigate("/");
  }, 3 * 1000);

  return <h1>Uspjesno izlogovani</h1>;
}

export default DummyLogout;
